<template>
    <v-dialog v-model="show" width="500">
        <v-card>
            <v-card-title class="headline grey lighten-2 text-capitalize" primary-title>
                {{$t('confirm')}}
            </v-card-title>
            <div class="pa-3">
                {{message}}
            </div>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="deny">
                    {{$t('cancel')}}
                </v-btn>
                <v-btn color="primary" @click="confirm">
                    {{$t('confirm')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

export default {
    name: 'Confirm',
    data () {
        return {
            show: false,
            promise: null,
            message: ''
        }
    },
    methods: {
        open (message) {
            this.message = message
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = { resolve, reject }
            })
        },
        confirm () {
            this.show = false
            this.promise.resolve(true)
        },
        deny () {
            this.show = false
            this.promise.reject(false)
        }
    }
}
</script>
